/**
 * 작성자 : 홍선영
 * 날짜 : 2024.10.29
 * 기능 : 설정관리-메인화면관리 페이지(사내 관리자)
 */

import { useEffect, useState } from 'react';
import { useOutletContext, useSearchParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';

import { ITabObject } from 'customTypes';
import { IUser, pageInfoState, userState } from '../../atoms';
import Tab from '../../components/Tab';
import DashboardSetting from '../sm_setting/setting4/dashboardSetting';
import SiteDashboardSetting from '../sm_setting/setting4/siteDashboardSetting';
import illustrator from '../../assets/images/illustration/74.svg';
import { useTranslation } from 'react-i18next';
import { COMPANY_DASHBOARD } from '../../_constants';

const EmptyData = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  user-select: none;
  padding-bottom: 8rem !important;
  img {
    width: 24rem;
    -webkit-user-drag: none;
  }
  p {
    color: var(--filled-violet);
    word-break: keep-all;
    text-align: center;
  }
  p:nth-child(2) {
    padding: 1rem;
    background-color: var(--tonal);
    border-radius: 0.5rem;
    margin: 1rem;
  }
  p:nth-child(3) {
    color: var(--text-tertiary);
    margin: 0 2rem;
  }
`;

const CSetting3 = (mqtt: any) => {
  const { t } = useTranslation();
  const size = useOutletContext<any>();
  const tabInfo = useRecoilValue(pageInfoState);
  const [currentTabMrCd, setCurrentTabMrCd] = useState(tabInfo.defaultMrCd);
  const userInfo = useRecoilValue<IUser>(userState);
  const { userMenuList } = userInfo;
  const [newTabList, setNewTabList] = useState<ITabObject[]>();
  const [searchParams] = useSearchParams();
  const tabCd = searchParams.get('tabCd');

  // URL의 tabCd 파라미터 변경 감지하여 탭 업데이트
  useEffect(() => {
    if (tabCd && tabCd !== currentTabMrCd) {
      setCurrentTabMrCd(tabCd);
    }
  }, [tabCd]);

  useEffect(() => {
    const arr: any[] = [];
    userMenuList?.map((v: any) => {
      const result = tabInfo?.tabList?.find((el: ITabObject) => el.mtCd === v.mtCd && el.mdCd === v.mdCd && el.mrCd === v.mrCd);
      if (result) {
        arr.push(result);
        setNewTabList(arr);
      }
    });
  }, [tabInfo.tabList]);

  const onClickTab = (mrCd: string) => {
    setCurrentTabMrCd(mrCd);
  };

  const renderPage = () => {
    const activeTab = newTabList?.find((el: ITabObject) => el.mrCd === currentTabMrCd);
    if (activeTab !== undefined) {
      const { mrCd } = activeTab;
      switch (mrCd) {
        case '001':
          return <DashboardSetting dGubun='c' />;
        case '002':
          return <SiteDashboardSetting mqtt={mqtt} dGubun={COMPANY_DASHBOARD} />; // 사내 상황판
      }
    }
    return undefined;
  };
  return (
    <div className='contents'>
      <Tab tabList={newTabList || tabInfo.tabList} currentTabMrCd={currentTabMrCd} setCurrentTabMrCd={setCurrentTabMrCd} onClickTab={onClickTab} size={size} />
      <div className='content-container oneColumn'>
        {size.innerSize.W > 1024 ? (
          renderPage()
        ) : (
          <EmptyData>
            <img src={illustrator} alt='noData' />
            <p>{t('데스크톱 환경에서 설정해 주세요')}</p>
            <p>{t('화면이 안 나오신다면 브라우저의 가로 폭을 늘려주세요')}</p>
          </EmptyData>
        )}
      </div>
    </div>
  );
};

export default CSetting3;
